/**
 * @file: 更新层高
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import {
    beamBootomIsEmpty,
    beamBootomIsBeamOrFoof,
    getBeamSpaceSize,
    firstNormalLayer,
    topLayerIsBeam,
    topIsNormalLayer
} from './scenes';

// 放置区域高度计算
export function layerHeightCompute(layer: CubeId): PhysicsMeasurement {
    let prevLayerCubeId: CubeId = CubeTree.findPrevCube(layer);
    let bottomLayer: CubeId = CubeTree.findNextCube(layer);

    // 顶板层高为 0
    if (CubeTree.isRoof(layer)) {
        return 0;
    }

    // 横杆, 且下方不存在层板
    if (CubeTree.isBeam(layer) && !bottomLayer) {
        return beamBootomIsEmpty(layer);
    }

    // 横杆, 下方是横杆或者顶板
    if (CubeTree.isBeam(layer)
        && (CubeTree.isBeam(bottomLayer)
            || CubeTree.isRoof(bottomLayer))) {
        return beamBootomIsBeamOrFoof(layer, bottomLayer);
    }

    // 横杆, 下方是普通层板，其层高为商品所占高度
    if (CubeTree.isBeam(layer)) {
        return getBeamSpaceSize(layer);
    }

    // 从上往下数，第一个普通层板
    if (CubeTree.isFirstCube(layer)) {
        return firstNormalLayer(layer);
    }

    // 普通层板，上方是横杆
    if (CubeTree.isBeam(prevLayerCubeId)) {
        return topLayerIsBeam(layer);
    }

    // 普通层板，上方也是普通层板或者顶板
    return topIsNormalLayer(layer);
}
